import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=562c52b4&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=562c52b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c52b4",
  null
  
)

export default component.exports